import React from 'react';
import Table from "components/Table/Table.jsx";
import SortButton from "components/SortButton/SortButton.jsx";

export const COMPANY_COLUMNS_META = [
    { accessor: 'number', Header: '#' },
    { accessor: 'company_name', Header: 'Company Name' },
    { accessor: 'main_phone', Header: 'Main Phone' },
    { accessor: 'created_date', Header: 'Created' },
    { accessor: 'created_by', Header: 'Created By' },
];

const CompaniesListTable = props => {
    const {
        setSort,
        sortDirection,
        sortBy,
        hiddenColumns = []
    } = props;

    const fullHead = [
        '#',
        <strong>Company Name<SortButton setSort={setSort} sortBy='company_name' sortDirection={sortDirection} currentSortBy={sortBy} /></strong>,
        <strong>Main Phone</strong>,
        <strong>Created<SortButton setSort={setSort} sortBy='created_date' sortDirection={sortDirection} currentSortBy={sortBy} /></strong>,
        <strong>Created By</strong>,
    ];

    const hiddenIdx = new Set();
    COMPANY_COLUMNS_META.forEach((c, i) => {
        if (hiddenColumns.indexOf(c.accessor) !== -1) hiddenIdx.add(i);
    });

    const filteredHead = fullHead.filter((_, i) => !hiddenIdx.has(i));
    const filteredData = (props.dataArr || []).map(row => row.filter((_, i) => !hiddenIdx.has(i)));

    return <div>
        <Table
            tableHeaderColor="primary"
            tableHead={filteredHead}
            tableData={filteredData}
        />
    </div>
}

export default CompaniesListTable;